export default defineNuxtPlugin(() => {
  if (process.client) {
    const scriptContent = `
      var _mtm = window._mtm = window._mtm || [];
      _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
      (function() {
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.async=true; g.src='http://matomo.fair.bi/js/container_2J6IpJJf.js'; s.parentNode.insertBefore(g,s);
      })();
    `;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = scriptContent;
    document.head.prepend(script);
  }
});
